import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { PopoverModule } from 'primeng/popover';
import { ProgressSpinner } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StepperModule } from 'primeng/stepper';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

import { environment } from '@environments/environment';

@Component({
  selector: 'company-module',
  templateUrl: './companies-loader.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    SelectModule,
    RouterModule,
    TableModule,
    InputTextModule,
    FormsModule,
    ChipModule,
    PopoverModule,
    CheckboxModule,
    ToastModule,
    ProgressSpinner,
    SelectButtonModule,
    RadioButtonModule,
    DatePickerModule,
    FormsModule,
    ReactiveFormsModule,
    TagModule,
    ToggleSwitchModule,
    TextareaModule,
    MultiSelectModule,
    TabsModule,
    InputNumberModule,
    FloatLabelModule,
    StepperModule,
    AccordionModule,
  ],
})
export class CompaniesLoaderComponent implements OnInit, OnDestroy {
  private observer: MutationObserver | null = null;
  form: FormGroup;
  activeStep = 0;

  value = signal('overview');

  routes: { label: string; value: string }[] = [
    { label: $localize`Overview`, value: 'overview' },
    { label: $localize`Contracts`, value: 'contracts' },
  ];

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      radiobutton: '',
      selectbutton: '',
      datepicker: '',
    });
  }

  ngOnInit(): void {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${environment.REMOTE_URL_COMPANY}/styles.css`;
    document.head.appendChild(link);

    const container = this.elRef.nativeElement.querySelector(
      '.companies-loader-container'
    );
    if (!container) return;

    const applyHeight = () => {
      const secondChild = container.children[1];
      if (secondChild) {
        this.renderer.setStyle(secondChild, 'height', '100%');
      }
    };

    applyHeight();

    this.observer = new MutationObserver(() => {
      applyHeight();
    });

    this.observer.observe(container, {
      childList: true,
      subtree: false,
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
